import React, { useState } from 'react';
import {deleteRole} from "../auth";
import ConfirmationModal from "./ConfirmationModal";
import { Role } from '../interfaces/Role';


interface RoleTableProps {
    roles: Role[];
    onEditRole: (role: Role) => void;
    refreshRoles: () => void;  // Nouvelle prop pour rafraîchir la liste des rôles
}

const RoleTable: React.FC<RoleTableProps> = ({ roles, onEditRole, refreshRoles }) => {
    const [filter, setFilter] = useState('');
    const [selectedRoles, setSelectedRoles] = useState<number[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [roleToDelete, setRoleToDelete] = useState<Role | null>(null);

    /*
    const handleDelete = async (roleId: number) => {
        try {
            await deleteRole(roleId);
            refreshRoles();
        } catch (error) {
            console.error('Erreur lors de la suppression du rôle:', error);
        }
    };
     */

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
    };

    const openModal = (role: Role) => {
        setRoleToDelete(role);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setRoleToDelete(null);
    };

    const confirmDelete = async () => {
        if (roleToDelete) {
            try {
                await deleteRole(roleToDelete.id);
                refreshRoles();
            } catch (error) {
                console.error('Erreur lors de la suppression du rôle:', error);
            } finally {
                closeModal();
            }
        }
    };

    const handleDeleteSelected = async () => {
        try {
            await Promise.all(selectedRoles.map(roleId => deleteRole(roleId)));
            refreshRoles();
            setSelectedRoles([]);
        } catch (error) {
            console.error('Erreur lors de la suppression des rôles sélectionnés:', error);
        }
    };

    const filteredRoles = roles.filter(
        (role) => role.name.toLowerCase().includes(filter.toLowerCase())
    );

    const handleSelectRole = (roleId: number) => {
        setSelectedRoles((prevSelected) =>
            prevSelected.includes(roleId)
                ? prevSelected.filter((id) => id !== roleId)
                : [...prevSelected, roleId]
        );
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow-md">
            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Filtrer par nom de rôle"
                    className="p-2 border rounded-md w-full"
                    value={filter}
                    onChange={handleFilterChange}
                />
            </div>
            <table className="w-full table-auto">
                <thead>
                <tr>
                    <th className="px-4 py-2 text-center w-12">
                        <input
                            type="checkbox"
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedRoles(roles.map((role) => role.id));
                                } else {
                                    setSelectedRoles([]);
                                }
                            }}
                            checked={selectedRoles.length === roles.length}
                        />
                    </th>
                    <th className="px-4 py-2 text-center w-20">Identifiant</th>
                    <th className="px-4 py-2 text-center w-40">Nom du rôle</th>
                    <th className="px-4 py-2 text-center w-60">Description</th>
                    <th className="px-4 py-2 text-center w-32">Actions</th>
                </tr>
                </thead>
                <tbody>
                {filteredRoles.map((role) => (
                    <tr key={role.id}>
                        <td className="px-4 py-2 text-center " >
                            <input
                                type="checkbox"
                                checked={selectedRoles.includes(role.id)}
                                onChange={() => handleSelectRole(role.id)}
                            />
                        </td>
                        <td className="px-4 py-2 text-center ">{role.id}</td>
                        <td className="px-4 py-2 text-center ">{role.name}</td>
                        <td className="px-4 py-2 text-center ">{role.description}</td>
                        <td className="px-4 py-2 text-center " >
                            <button
                                onClick={() => onEditRole(role)}
                                disabled={true}
                                className="bg-green-500 text-white px-2 py-1 rounded-md mr-2"
                                title={'Modifier le rôle'}
                            >
                                <i className={'fas fa-pen-to-square text-medium'}></i>
                            </button>
                            <button
                                onClick={() => openModal(role)}
                                disabled={true}
                                className="bg-red-500 text-white px-2 py-1 rounded-md"
                                title={'Supprimer le rôle'}
                            >
                                <i className={'fas fa-trash-can text-medium'}></i>
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            {selectedRoles.length > 0 && (
                <div className="mt-4 text-left">
                    <button
                        onClick={handleDeleteSelected}
                        disabled={true}
                        className="bg-red-500 text-white px-4 py-2 rounded-md"
                        title={'Supprimer la sélection'}
                    >
                        <i className={'fas fa-trash-can text-xl'}></i>
                    </button>
                </div>
            )}
            <ConfirmationModal
                isOpen={isModalOpen}
                onClose={closeModal}
                onConfirm={confirmDelete}
                message={`Êtes-vous sûr de vouloir supprimer le rôle "${roleToDelete?.name}" ?`}
            />
        </div>
    );
};


export default RoleTable;
